import { render, staticRenderFns } from "./course.vue?vue&type=template&id=4b007e7e&scoped=true"
import script from "./course.vue?vue&type=script&lang=ts"
export * from "./course.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b007e7e",
  null
  
)

export default component.exports